module.exports = __webpack_public_path__ + "img/cavu-app-icon.b947471.png";